import { observable, set, computed } from 'mobx';
import { ISortOption, IProdObjListItem } from '../../interfaces/ISearchInterfaces';

export interface ISearchCatalog {
    prodObjListItems: IProdObjListItem[];
    sortByOptions: ISortOption[];
    totalNumRecs: number;
}

export class SearchCatalog {
    @observable public sortByOptions: ISortOption[] = [];
    @observable public totalNumRecs: number;
    @observable public lastRecNum: number;
    @observable public originalTerm: string;
    @observable public adjustedTerm: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @observable public endecaRedirectUrl: any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @observable public adjustedSearches: any;
    @observable public productIds: string[] = [];
    @observable public productsNumber: number;
    @observable public sortOptions: ISortOption[] = [];
    @observable public prodObjListItems: IProdObjListItem[] = [];
    @observable public defaultSkuIds: string[] = [];
    @observable public skuIds: string[] = [];

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public static fromJSON(data: any): SearchCatalog {
        const searchCatalog = new SearchCatalog();
        set(searchCatalog, data);

        return searchCatalog;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public update = (data: any) => {
        set(this, data);
        this.productsNumber = data.totalNumRecs;
        this.sortOptions = data.sortByOptions;
        this.totalNumRecs = data.totalNumRecs;
        this.lastRecNum = data.lastRecNum;
        this.originalTerm = data.originalTerm;
        this.adjustedTerm = data.adjustedTerm;
        this.adjustedSearches = data.adjustedSearches;
        this.prodObjListItems = [];
        this.productIds = [];
        this.defaultSkuIds = [];
        this.skuIds = [];

        const catalog: ISearchCatalog = {
            prodObjListItems: data.prodObjListItems,
            sortByOptions: data.sortByOptions,
            totalNumRecs: data.totalNumRecs
        };

        if (catalog.prodObjListItems.length > 0) {
            this.prodObjListItems = catalog.prodObjListItems;

            this.prodObjListItems.forEach((prodObjListItem) => {
                this.productIds.push(prodObjListItem.productId);
                this.defaultSkuIds.push(prodObjListItem.defaultSkuId);
                prodObjListItem.skuIds.forEach((skuId) => {
                    this.skuIds.push(skuId);
                });
            });
        }

        if (catalog.totalNumRecs) {
            this.totalNumRecs = catalog.totalNumRecs;
        }
    };

    @computed
    public get numRecs() {
        return {
            totalNumRecs: this.totalNumRecs,
            contentTotalNumRecs: this.totalNumRecs,
            lastRecNum: this.lastRecNum
        };
    }
}
